import React from 'react';
import { Container, Row } from 'reactstrap';
import Basic from './Basic';
import CustomDirectionsClass from './CustomDirections';
import CustomAutocloseClass from './CustomAutoclose';
import { Breadcrumbs } from '../../../AbstractElements';

const BootstrapNotifyContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Basic Card' parent='Bonus Ui' title='Basic Card' />
      <Row>
        <Basic />
        <CustomDirectionsClass />
        <CustomAutocloseClass />
      </Row>
    </Container>
  );
};

export default BootstrapNotifyContain;
